<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8" class="text-center">
          <!-- <img src="/img/brand/logo_chorum.png"> -->
        </b-col>
        <b-col md="6">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <div class="text-center logo-login">
                 <img src="/img/brand/Harmonie-ESS-Logo.svg">
                </div>
                <b-form class="form" action="/auth/login" method="post">
                  <b-input-group class="mb-3" :class="{hasError: errors.email !== ''}">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-user"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      type="text"
                      class="form-control"
                      name="email"
                      v-model="email"
                      placeholder="Adresse mail"
                      autocomplete="username email"
                      tabindex="1"
                    />
                  </b-input-group>
                  <span class="field-error">{{ errors.email }}</span>
                  <b-input-group class="mb-4" :class="{hasError: errors.password !== ''}">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-lock"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      :type="passwordFieldType"
                      class="form-control"
                      name="password"
                      v-model="password"
                      placeholder="Mot de passe"
                      autocomplete="current-password"
                      tabindex="2"
                    />
                    <button type="button" class="btn btn-primary" @click="switchVisibility"><i :class="eye"></i></button>
                  </b-input-group>

                  <!-- <span class="field-error">{{ errors.password }}</span> -->
                  <b-row>
                    <b-col cols="12">
                      <b-button type="submit" variant="primary" tabindex="3" class="px-4 full-width" @click.prevent="login()">Connexion</b-button>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12" class="text-right">
                      <b-button
                        variant="link"
                        tabindex="4"
                        class="px-0"
                        @click.prevent="forgot_passwd()"
                      >Mot de passe oublié ?</b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import {
  isLoggedIn,
  handleLogin,
  handleLogout,
  getBaseUrl,
  getProvider
} from "../../utils/auth";

export default {
  data() {
    return {
      email: "",
      password: "",
      passwordFieldType: 'password',
      eye : 'fa fa-eye',
      reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      errors: {
        email: "",
        password: ""
      }
    };
  },
  methods: {
    switchVisibility() {
      this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
      this.eye = this.passwordFieldType === 'password' ? 'fa fa-eye' : 'fa fa-eye-slash';
    },
    isLoggedIn() {
      return isLoggedIn();
    },
    validateForm() {
      this.clearErrors();
      let valid = true;
      if (this.email === "") {
        this.errors.email = "Veuillez entrer une adresse email";
        valid = false;
      }
      if (!this.reg.test(this.email)) {
        this.errors.email = "Adresse email invalide";
        valid = false;
      }
      if (this.password === "") {
        this.errors.password = "Veuillez entrer un mot de passe";
        valid = false;
      }
      return valid;
    },
    login() {
      if (this.validateForm()) {
        this.$store.commit("IS_LOADING", true);
        let self = this;

        this.$axios.defaults.baseURL = getBaseUrl();
        this.$axios.defaults.headers.common["Accept"] = "application/json";
        this.$axios.defaults.headers.common["Provider"] = getProvider();

        let dataPost = {};
        dataPost.email = this.email.toLowerCase();
        dataPost.password = this.password;
        dataPost.provider = getProvider();

        this.$axios
          .post("/auth/login", dataPost)
          .then(response => {
            handleLogin(response.data);
            this.$store.commit("HANDLE_USER");
            this.$store.commit("IS_LOADING", false);
            this.$store.dispatch('setIsFromLogin', true);
            this.$router.push({ name: "Accueil" });
          })
          .catch(function(error) {
            let errorMessage = "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI"
            if (error.response) {
              if (error.response.status === 401) {
                self.errors.email = error.response.data.message
                errorMessage = error.response.data.message
              } else if (error.response.status === 406) {
                self.errors.email = "Votre compte est temporairement bloqué"
                errorMessage = "Votre compte est temporairement bloqué"
              }
            }
            self.$store.commit("IS_LOADING", false);
            self.$swal({
              position: "top",
              type: "error",
              title: "Attention !!",
              text: errorMessage,
              showConfirmButton: false,
              timer: 5000
            });
          });
      }
    },
    forgot_passwd() {
      this.$router.push({ name: "ForgotPasswd" });
    },
    clearErrors() {
      this.errors.email = "";
      this.errors.password = "";
    }
  },
  created(){
    if(this.$route.query.t == 'a'){
      this.$swal({
        position: "top",
        type: "warning",
        title: "Attention !!",
        text: "Vous avez été deconnecté, veuillez vous reconnecter",
        showConfirmButton: true
      });
    }

  }
};
</script>

<style>
  body {
    background-image: url("/../../../img/background/montagne.png");
    background-repeat: no-repeat;
    background-size: cover;
  }
  .logo-login img{
    width: 210px;
    margin-bottom: 25px;
  }
  .full-width {
    width: 100%
  }
</style>
